import { dateFormat } from '@app/constants'

import { toDayjs } from '../filters/adapters'

import type { ObjectValuesType } from '@app/types'

export const getDateDiff = (
  dateLeftRaw: string,
  dateRightRaw: string,
  format: ObjectValuesType<typeof dateFormat>
): number => {
  const dateLeftFormatted = toDayjs(dateLeftRaw, format)
  const dateRightFormatted = toDayjs(dateRightRaw, format)

  return dateLeftFormatted.diff(dateRightFormatted)
}
